import React from 'react'
import styled from 'styled-components'

function ProgressBar({percentage}) {
  return (
    <Progress>
        <div className="inner-bar linear-gradient" style={{width: `${percentage}%`}} ></div>
    </Progress>
  )
}
const Progress = styled.div`
    width: 100%;
    height: 0.8rem;
    background-color: var(--white);
    box-shadow: 1px 19px 34px #31333577;
    border-radius: 25px;
    overflow: hidden;

    .inner-bar{
        height: 100%;
        border-radius: 25px;
    }

`;

export default ProgressBar;